// ** Third Party Components
import styled, { css } from "styled-components";
// #####################################################

export const StyledCheckboxControl = styled("div")`
	cursor: pointer;
	color: ${({ theme: { colors } }) => colors.whiteTrue};
	display: inline-block;
	width: 16px;
	height: 16px;

	border-radius: ${({ theme: { borderRadius } }) => borderRadius.minimal};
	border: 1px solid transparent;
	text-align: center;
	vertical-align: inherit;

	${({ disabled }) =>
		disabled &&
		css`
			cursor: not-allowed;
			opacity: 0.75;
		`}
`;

// #####################################################
